import { Link } from "react-router-dom";
import { Facebook, Instagram, MessageCircle, Phone, Mail } from "lucide-react";
import { useSettings } from "@/lib/settings";

export default function Footer() {
  const { settings } = useSettings();
  return (
    <footer className="bg-[color:var(--color-primary)] text-[color:var(--color-bg)] mt-24" data-testid="site-footer">
      <div className="container-x px-6 py-16 grid grid-cols-1 md:grid-cols-4 gap-12">
        <div className="md:col-span-2">
          <div className="flex items-center gap-3 mb-4">
            <img src="/logo.jpg" alt="AlikamaFish" className="h-12 w-12 rounded-full object-cover ring-2 ring-[color:var(--color-accent)]/40" />
            <div className="font-display text-3xl">{settings.business_name}</div>
          </div>
          <p className="text-sm text-white/70 max-w-md leading-relaxed">
            {settings.tagline}. Sourced from sustainable fisheries, delivered fresh to your door — and onto your plate.
          </p>
          <div className="flex items-center gap-4 mt-6">
            <a href={settings.facebook} target="_blank" rel="noreferrer" aria-label="Facebook" data-testid="footer-facebook" className="hover:text-[color:var(--color-accent)] transition">
              <Facebook className="w-5 h-5" />
            </a>
            <a href={settings.instagram} target="_blank" rel="noreferrer" aria-label="Instagram" data-testid="footer-instagram" className="hover:text-[color:var(--color-accent)] transition">
              <Instagram className="w-5 h-5" />
            </a>
            <a href={settings.tiktok} target="_blank" rel="noreferrer" aria-label="TikTok" data-testid="footer-tiktok" className="hover:text-[color:var(--color-accent)] transition">
              <svg className="w-5 h-5" viewBox="0 0 24 24" fill="currentColor"><path d="M12 2v12.5a2.5 2.5 0 1 1-2.5-2.5"/><path d="M16 2c0 3.31 2.69 6 6 6"/></svg>
            </a>
            <a href={`https://wa.me/${settings.phone.replace(/[^0-9]/g, '')}`} target="_blank" rel="noreferrer" aria-label="WhatsApp" data-testid="footer-whatsapp" className="hover:text-[color:var(--color-accent)] transition">
              <MessageCircle className="w-5 h-5" />
            </a>
          </div>
        </div>

        <div>
          <h4 className="font-display text-xl mb-4">Explore</h4>
          <ul className="space-y-2 text-sm text-white/70">
            <li><Link to="/products" className="hover:text-white" data-testid="footer-link-products">Fish Products</Link></li>
            <li><Link to="/classes" className="hover:text-white" data-testid="footer-link-classes">Cooking Classes</Link></li>
            <li><Link to="/subscriptions" className="hover:text-white" data-testid="footer-link-subscriptions">Subscriptions</Link></li>
            <li><Link to="/event-chef" className="hover:text-white" data-testid="footer-link-event-chef">Event Chef</Link></li>
            <li><Link to="/blog" className="hover:text-white" data-testid="footer-link-blog">Blog</Link></li>
            <li><Link to="/faq" className="hover:text-white" data-testid="footer-link-faq">FAQ</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="font-display text-xl mb-4">Contact</h4>
          <ul className="space-y-3 text-sm text-white/70">
            <li className="flex items-center gap-2"><Phone className="w-4 h-4"/> <a href={`tel:${settings.phone}`} className="hover:text-white" data-testid="footer-phone">{settings.phone}</a></li>
            <li className="flex items-center gap-2"><Mail className="w-4 h-4"/> <a href={`mailto:${settings.email}`} className="hover:text-white" data-testid="footer-email">{settings.email}</a></li>
            <li><Link to="/support" className="hover:text-white" data-testid="footer-link-support">Support</Link></li>
            <li><Link to="/admin/login" className="hover:text-white text-xs opacity-50" data-testid="footer-admin-link">Admin</Link></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="container-x px-6 py-6 text-xs text-white/50 flex flex-col md:flex-row md:items-center md:justify-between gap-2">
          <span>© {new Date().getFullYear()} {settings.business_name}. All rights reserved.</span>
          <span>Sustainably sourced. Ethically delivered.</span>
        </div>
      </div>
    </footer>
  );
}
